import isEqual from 'lodash/isEqual';
export const setFormDataForCreateCompany = (profile) => {
  const data = profile?.onboardingData?.onboardingSteps?.createCompany;
  return {
    companyName: data?.companyName,
    companyLocation: {
      label: data?.companyLocation,
      value: data?.companyLocation,
    },
    phoneNumber: data?.phoneNumber,
    timezone: { label: data?.timezone, value: data?.timezone },
    startTime: data?.startTime,
    endTime: data?.endTime,
  };
};
export const setFormDataForCreateTeam = (profile) => {
  const data = profile?.onboardingData?.onboardingSteps?.createTeam;
  return {
    teamName: data?.teamName,
  };
};
export const setFormDataForCreateEmployee = (profile) => {
  const data = profile?.onboardingData?.onboardingSteps?.createEmployee;
  return {
    employees: data?.employees,
  };
};

export const isFormDataChanged = ({ orignalData, newData, currentStep }) => {
  switch (currentStep) {
    case 1:
      return !isEqual(orignalData, newData);
    case 2:
      return !isEqual(orignalData, newData);
    case 3:
      return true;
    default:
      return false;
  }
};
